<template>
  <form v-if="!loading" @submit.prevent="onSubmit()">
    <div class="row mb-2">
      <div class="col-12">
        <b-checkbox v-model="network.active">Ativo</b-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-4 col-xl-3">
        <app-input
          label="CNPJ Matriz"
          v-model="network.cnpj"
          v-mask="'##.###.###/####-##'"
          :errors="errors.cnpj"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="Nome"
          v-model="network.name"
          :errors="errors.name"
          required
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="E-mail"
          v-model="network.email"
          :errors="errors.email"
        ></app-input>
      </div>
      <div class="col-sm-6 col-lg-2 col-xl-3">
        <b-field label="Data Mínima de Vendas" required>
          <b-datepicker
            v-model="network.min_date"
            :date-formatter="bDateFormatter"
            :years-range="[-100, 100]"
            placeholder="Selecionar data..."
            trap-focus
          ></b-datepicker>
        </b-field>
      </div>
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="Telefone"
          v-model="network.phone"
          v-mask="'(##) ####-####'"
          :errors="errors.phone"
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-lg-3">
        <app-input
          label="Rua"
          v-model="network.address.street"
          :errors="errors['address.street']"
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Número"
          v-model="network.address.number"
          :errors="errors['address.number']"
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Complemento"
          v-model="network.address.complement"
          :errors="errors['address.complement']"
        ></app-input>
      </div>
      <div class="col-sm-4 col-lg-3 col-xl-2">
        <app-input
          label="Bairro"
          v-model="network.address.neighborhood"
          :errors="errors['address.neighborhood']"
        ></app-input>
      </div>
      <div class="col-sm-4 col-lg-3">
        <app-autocomplete
          label="Cidade"
          field="name_with_state"
          :searchFunction="searchCityFn"
          :resourceIdFunction="resourceCityFn"
          v-model="network.address.city_id"
          :errors="errors['address.city_id']"
        ></app-autocomplete>
      </div>
    </div>
    <div class="row d-flex align-items-end">
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Gerente"
          v-model="network.comission_manager"
          v-money="moneyConfig"
          :errors="errors.comission_manager"
          required
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Subgerente"
          v-model="network.comission_submanager"
          v-money="moneyConfig"
          :errors="errors.comission_submanager"
          required
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Gerente Regional"
          v-model="network.comission_regional_manager"
          v-money="moneyConfig"
          :errors="errors.comission_regional_manager"
          required
        ></app-input>
      </div>
      <div class="col-sm-3 col-lg-2">
        <app-input
          label="Supervisor Regional"
          v-model="network.comission_regional_supervisor"
          v-money="moneyConfig"
          :errors="errors.comission_regional_supervisor"
          required
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import CityService from '@/services/city.service';
import NetworkService from '@/services/network.service';
import ToastMixin from '@/mixins/ToastifyMixin';
import BuefyMixin from '@/mixins/BuefyMixin';
import NumberMixin from '@/mixins/NumberMixin';

import { required, email } from 'vuelidate/src/validators';
import * as moment from 'moment';

export default {
  name: 'network-form',
  props: ['id', 'errors', 'saving'],
  mixins: [ToastMixin, BuefyMixin, NumberMixin],
  data: () => {
    return {
      loading: true,
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        suffix: ' %',
      },
      network: {
        active: true,
        cnpj: null,
        name: null,
        email: null,
        phone: null,
        min_date: null,
        comission_manager: null,
        comission_submanager: null,
        comission_regional_manager: null,
        comission_regional_supervisor: null,
        address: {
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city_id: null,
        },
      },
    };
  },
  validations: {
    network: {
      cnpj: { required },
      name: { required },
      email: {
        email,
      },
      min_date: { required },
      comission_manager: { required },
      comission_submanager: { required },
      comission_regional_manager: { required },
      comission_regional_supervisor: { required },
    },
  },
  methods: {
    loadNetwork(id) {
      NetworkService.getId(id)
        .then(({ data: network }) => {
          this.network = {
            ...network,
            address: network.address || {},
            min_date: network.min_date ? new Date(network.min_date) : null,
            comission_manager: network.comission_manager.toFixed(2),
            comission_submanager: network.comission_submanager.toFixed(2),
            comission_regional_manager: network.comission_regional_manager.toFixed(
              2
            ),
            comission_regional_supervisor: network.comission_regional_supervisor.toFixed(
              2
            ),
          };
        })
        .catch(() => this.toastify('Erro ao carregar Rede.', 'error'))
        .finally(() => (this.loading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.network,
        cnpj: this.network.cnpj.replace(/\D/g, ''),
        min_date: moment(this.network.min_date).format('DD/MM/YYYY'),
        comission_manager: this.parseDecimalInput(
          this.network.comission_manager
        ),
        comission_submanager: this.parseDecimalInput(
          this.network.comission_submanager
        ),
        comission_regional_manager: this.parseDecimalInput(
          this.network.comission_regional_manager
        ),
        comission_regional_supervisor: this.parseDecimalInput(
          this.network.comission_regional_supervisor
        ),
      });
    },
    searchCityFn: CityService.search,
    resourceCityFn: CityService.getId,
  },
  beforeMount() {
    if (this.id) this.loadNetwork(this.id);
    else this.loading = false;
  },
};
</script>

<style lang="scss" scoped></style>
